#define  PI 3.1415926535897932384626433832795
uniform float uTime;
varying vec2 vuv;

float random(vec2 st)
{
    return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.545123);
}

vec2 rotate (vec2 uv, float rotation, vec2 mid)
{
    return vec2(
        cos(rotation)*(uv.x - mid.x) + sin(rotation)*(uv.y - mid.y) + mid.x,
        cos(rotation)*(uv.y - mid.y) - sin(rotation)*(uv.x - mid.x) + mid.y
    );
}

vec2 fade(vec2 t)
{
    return t*t*t*(t*(t*6.0-15.0)+10.0);
}

//	Classic Perlin 2D Noise 
//	by Stefan Gustavson
//
vec4 permute(vec4 x)
{
    return mod(((x*34.0)+1.0)*x, 289.0);
}

float cnoise(vec2 P)
{
    vec4 Pi = floor(P.xyxy) + vec4(0.0, 0.0, 1.0, 1.0);
    vec4 Pf = fract(P.xyxy) - vec4(0.0, 0.0, 1.0, 1.0);
    Pi = mod(Pi, 289.0); // To avoid truncation effects in permutation
    vec4 ix = Pi.xzxz;
    vec4 iy = Pi.yyww;
    vec4 fx = Pf.xzxz;
    vec4 fy = Pf.yyww;
    vec4 i = permute(permute(ix) + iy);
    vec4 gx = 2.0 * fract(i * 0.0243902439) - 1.0; // 1/41 = 0.024...
    vec4 gy = abs(gx) - 0.5;
    vec4 tx = floor(gx + 0.5);
    gx = gx - tx;
    vec2 g00 = vec2(gx.x,gy.x);
    vec2 g10 = vec2(gx.y,gy.y);
    vec2 g01 = vec2(gx.z,gy.z);
    vec2 g11 = vec2(gx.w,gy.w);
    vec4 norm = 1.79284291400159 - 0.85373472095314 * vec4(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));
    g00 *= norm.x;
    g01 *= norm.y;
    g10 *= norm.z;
    g11 *= norm.w;
    float n00 = dot(g00, vec2(fx.x, fy.x));
    float n10 = dot(g10, vec2(fx.y, fy.y));
    float n01 = dot(g01, vec2(fx.z, fy.z));
    float n11 = dot(g11, vec2(fx.w, fy.w));
    vec2 fade_xy = fade(Pf.xy);
    vec2 n_x = mix(vec2(n00, n01), vec2(n10, n11), fade_xy.x);
    float n_xy = mix(n_x.x, n_x.y, fade_xy.y);
    return 2.3 * n_xy;
}

void main()
{
    //gl_FragColor = vec4(0.5, 0.0, 1.0, 1.0);
    //gl_FragColor = vec4(vuv.x, vuv.y, 1.0, 1.0);
    //gl_FragColor = vec4(vuv, 1.0, 1.0);
    //gl_FragColor = vec4(vuv.x, vuv.x, vuv.x, 1.0);
    
    //float strength = vuv.x;

    //float strength =  mod(10.0 * vuv.y, 1.0);
    //float strength =  step(0.5, mod(10.0 * vuv.y, 1.0));
    //float strength =  step(0.8, mod(10.0 * vuv.y, 1.0));

    //float strength =  step(0.8, mod(10.0 * max(vuv.x, vuv.y), 1.0));

    //float strength =  step(0.8, mod(10.0 * vuv.x, 1.0)) + step(0.8, mod(10.0 * vuv.y, 1.0));
    
    //float strength =  step(0.8, mod(10.0 * vuv.x, 1.0)) * step(0.8, mod(10.0 * vuv.y, 1.0));
    
    // float patternX =  step(0.4, mod(10.0 * vuv.x, 1.0)) * step(0.8, mod(10.0 * vuv.y, 1.0));
    // float patternY =  step(0.8, mod(10.0 * vuv.x, 1.0)) * step(0.4, mod(10.0 * vuv.y, 1.0));
    // float strength = patternY + patternX;

    // float patternX =  step(0.4, mod(10.0 * vuv.x, 1.0)) * step(0.8, mod(10.0 * vuv.y + 0.2, 1.0));
    // float patternY =  step(0.8, mod(10.0 * vuv.x + 0.2, 1.0)) * step(0.4, mod(10.0 * vuv.y, 1.0));
    // float strength = patternY + patternX;

    //float strength = min(abs(vuv.x - 0.5), abs(vuv.y - 0.5));
    
    //float strength = max(abs(vuv.x - 0.5), abs(vuv.y - 0.5));
    //float strength = step(0.4, max(abs(vuv.x - 0.5), abs(vuv.y - 0.5)));

    //float strength = floor(vuv.x*vuv.y * 10.0) / 10.0;

    //float strength = floor(vuv.x * 10.0) * floor(vuv.y * 10.0) / 100.0;
    //float strength = random(vuv);
    //float strength = length(vuv); //26
    //float strength = distance(vuv, vec2(0.5)); //27
    //float strength = 1.0 - distance(vuv, vec2(0.5)); // Pattern 28
    //float strength = 0.02 / distance(vuv, vec2(0.5)); // Pattern 29
    //float strength = 0.02 / distance(vec2(vuv.x *0.2 +0.4, vuv.y), vec2(0.5)); // Pattern 30

    // float strengthX = 0.02 / distance(vec2(vuv.x *0.2 +0.4, vuv.y), vec2(0.5)); // Pattern 31
    // float strengthY = 0.02 / distance(vec2(vuv.x, vuv.y *0.2 +0.4), vec2(0.5)); // Pattern 31
    // float strength = strengthX*strengthY;//31

    // vec2 rotatedUV = rotate(vuv, PI/4.0, vec2(0.5)); // 32
    // float strengthX = 0.02 / distance(vec2(rotatedUV.x *0.2 +0.4, rotatedUV.y), vec2(0.5)); // Pattern 32
    // float strengthY = 0.02 / distance(vec2(rotatedUV.x, rotatedUV.y *0.2 +0.4), vec2(0.5)); // Pattern 32
    // float strength = strengthX*strengthY; //32

    //float strength = step(0.25, distance(vuv, vec2(0.5))); // Pattern 33

    // float strength = abs(distance(vuv, vec2(0.5)) - 0.25); // Pattern 34

    // float strength = step(0.01, abs(distance(vuv, vec2(0.5)) - 0.25)); // Pattern 35

    // float strength = 1.0 - step(0.01, abs(distance(vuv, vec2(0.5)) - 0.25)); // Pattern 36
    
    // vec2 wavedUV = vec2(vuv.x, vuv.y + sin(vuv.x * 30.0) * 0.1); //37
    // float strength = 1.0 - step(0.01, abs(distance(wavedUV, vec2(0.5)) - 0.25)); // Pattern 37

    // vec2 wavedUV = vec2(vuv.x + sin(vuv.y * 30.0) * 0.1, vuv.y + sin(vuv.x * 30.0) * 0.1); //38
    // float strength = 1.0 - step(0.01, abs(distance(wavedUV, vec2(0.5)) - 0.25)); // Pattern 38

    // vec2 wavedUV = vec2(vuv.x + sin(vuv.y * 100.0) * 0.1, vuv.y + sin(vuv.x * 100.0) * 0.1); //39
    // float strength = 1.0 - step(0.01, abs(distance(wavedUV, vec2(0.5)) - 0.25)); // Pattern 39

    // float angle = atan(vuv.x, vuv.y); //40
    // float strength = angle; // Pattern 40

    // float angle = atan(vuv.x - 0.5, vuv.y -0.5); //41
    // float strength = angle; // Pattern 41

    // float angle = atan(vuv.x - 0.5, vuv.y -0.5); //42
    // angle /= PI * 2.0;
    // angle += 0.5;
    // float strength = angle; // Pattern 42

    // float angle = atan(vuv.x - 0.5, vuv.y -0.5);//43
    // angle /= PI * 2.0;//43
    // angle += 0.5;//43
    // angle *= 25.0;//43
    // angle = mod(angle, 1.0);//43
    // float strength = angle;//43

    // // 44 --------------------------------
    // float angle = atan(vuv.x - 0.5, vuv.y -0.5);
    // angle /= PI * 2.0;
    // angle += 0.5;
    // float strength = sin(angle * 100.0);

    // 45 --------------------------------
    // float angle = atan(vuv.x - 0.5, vuv.y -0.5);
    // angle /= PI * 2.0;
    // angle += 0.5;
    // float sinusoid = sin(angle * 30.0 * PI);

    // float radius = 0.25 + sinusoid * 0.02;
    // float strength = 1.0 - step(0.01, abs(distance(vuv, vec2(0.5)) - radius));

    // 46 --------------------------------
    // float strength = cnoise(vuv * 10.0);
    
    // // 47 --------------------------------
    // float strength = step(0.0,cnoise(vuv * 10.0));

    // // 48 --------------------------------
    // float strength = 1.0 - abs(cnoise(vuv * 10.0));

    // // 49 --------------------------------
    // float strength = sin(cnoise(vuv * 10.0) * 20.0);

    // 50 --------------------------------
    //float modulus = 10.0;
    //float absOffset = modulus * 0.5;
    //float varianceMax = 2.0;
    //float varianceMin = varianceMax * 0.5;
    //float variance = varianceMax - abs(mod(uTime, modulus) - absOffset) * varianceMin;
    float noiseFactor = 1.0 * sin(uTime);
    float stepFactor = (1.5 - sin(3.0*uTime));

    //noiseFactor = 0.0;
    //stepFactor = 1.0;

    float strength = step(0.7, sin(cnoise(vuv * 20.0 + noiseFactor) * 25.0 * stepFactor));
    


    strength = clamp(strength, 0.0, 1.0);
    vec3 blackColor = vec3(0.0);
    vec3 uvColor = vec3(vuv, 1.0);
    vec3 mixedColor = mix(blackColor, uvColor, strength);

    gl_FragColor = vec4(mixedColor, 1.0);

    // black and white 
    //gl_FragColor = vec4(strength, strength, strength, 1.0);

}